import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  fareCard: {
    backgroundColor: '#fff',
    border: `1px solid ${Theme.palette.gray[250]}`,
    borderRadius: '8px',
    padding: '20px',
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
  },
  fareCardSelected: {
    backgroundColor: '#fff',
    border: `2px solid ${Theme.palette.primary.main}`,
    borderRadius: '8px',
    padding: '20px',
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '12px',
  },
  headerLeft: {
    flex: 1,
  },
  headerRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '6px',
    flexShrink: 0,
    marginLeft: '12px',
  },
  toggleDetails: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    fontSize: Theme.typography.size[1],
    color: Theme.palette.primary.light,
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
  },
  brandName: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    fontWeight: 600,
    lineHeight: '150%',
    color: Theme.palette.gray[800],
    margin: '0 0 10px 0',
  },
  chipsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'center',
  },
  onSaleChip: {
    backgroundColor: '#F5E8FB',
    color: '#5F1477',
    border: '1px solid #E3B7F1',
    fontWeight: 600,
    borderRadius: '12px',
    '& .MuiChip-label': { padding: '0 10px' },
  },
  onSaleChipCelebrity: {
    backgroundColor: '#E8F3F4',
    color: '#275B63',
    fontWeight: 700,
    borderRadius: 0,
    clipPath: 'polygon(8px 0, 100% 0, calc(100% - 8px) 100%, 0 100%)',
    '& .MuiChip-label': { padding: '0 14px' },
  },
  propChip: {
    backgroundColor: '#E8F1FE',
    color: Theme.palette.primary.main,
    fontWeight: 600,
    borderRadius: '12px',
    '& .MuiChip-label': { padding: '0 10px' },
  },
  payBadge: {
    borderRadius: '12px',
    padding: '2px 10px',
    fontSize: Theme.typography.size[1],
    fontWeight: 600,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  payBadgeNow: {
    backgroundColor: '#E9F6F0',
    color: '#33734F',
    border: '1px solid #BCE2D2',
  },
  payBadgeLater: {
    backgroundColor: '#439465',
    color: '#FFFFFF',
    border: '1px solid #439465',
  },
  payLabel: {
    fontSize: Theme.typography.size[1],
    fontWeight: 700,
    padding: '3px 14px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    backgroundColor: '#E8F3F4',
    clipPath: 'polygon(8px 0, 100% 0, calc(100% - 8px) 100%, 0 100%)',
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  payLabelNow: {
    color: '#4C200B',
  },
  payLabelLater: {
    backgroundColor: '#439465',
    color: '#FFFFFF',
  },
  body: {
    display: 'flex',
    flexDirection: 'row',
    gap: '24px',
    [Theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '12px',
    },
  },
  leftCol: {
    flex: '0 0 35%',
    maxWidth: '35%',
    [Theme.breakpoints.down('sm')]: {
      flex: 'none',
      maxWidth: '100%',
    },
  },
  rightCol: {
    flex: 1,
    minWidth: 0,
  },
  ctaCol: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    flexShrink: 0,
    minWidth: '140px',
    [Theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      minWidth: 'auto',
    },
  },
}));

export default useStyles;
